import { render, staticRenderFns } from "./TransferScreen.vue?vue&type=template&id=0721e63b&"
import script from "./TransferScreen.vue?vue&type=script&lang=js&"
export * from "./TransferScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports